module.exports = __webpack_public_path__ + "static/web_wireframe_cover-34ca4166414a966ceafc54fa8a2ef2e6.png";